import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { LoginNaked } from 'core/components/Login';
import Overlay from 'core/components/Overlay';
import Close from 'core/icons/Close';
import { parseQuery } from 'core/utils/getQueryParam';
import { serialize } from 'core/utils/objectUtils';

import { LoginWrapper, DismissBtn } from './styles';

class LoginModalHoc extends Component {
	state = {
		showLoginModal: false,
		urlParam: null,
		contextUsage: this.props.contextUsage,
	}

	// param is a little breadcrumb that will persist after login
	// then you can check for the param and open a modal after login
	// for example, `write_review` will set `write_review=true` in url
	triggerLoginModal = (param = null, contextOverride = null) => {
		const { showLoginModal, contextUsage } = this.state;

		if (typeof param === "string") {
			// preserve the old query params
			let queryParams = parseQuery(window.location.search);
			// update the target param:
			queryParams[param] = !showLoginModal ? 'true' : 'false';
			queryParams = serialize(queryParams);

			history.pushState({ [param]: !showLoginModal },
				null,
				`?${queryParams}`
			);
		}

		// Clear param if modal will close or param wasnt valid
		if (showLoginModal || typeof param !== "string") {
			param = null;
		}

		this.setState({ showLoginModal: !showLoginModal, urlParam: param, contextUsage: contextOverride || contextUsage });
	}

	componentDidMount () {
		// Hackity hack to talk with backbone
		// won't need that later on...
		if (window.cj.loginModal !== undefined) return;
		window.cj.loginModal = this;
	}

	componentWillUnmount () {
		window.cj.loginModal = undefined;
	}

	render () {
		const { triggerLoginModal } = this;
		const { showLoginModal, contextUsage } = this.state;
		const passedProps = {
			triggerLoginModal,
		};

		return (
			<Fragment>
				{showLoginModal && (
					<Overlay noCloseBtn dismiss={() => triggerLoginModal(this.state.urlParam)} noOverflow>
						<LoginWrapper>
							<DismissBtn onClick={() => triggerLoginModal(this.state.urlParam)}>
								<Close width="10" height="10" fill="currentColor" />
							</DismissBtn>
							<LoginNaked modalMode contextUsage={contextUsage} />
						</LoginWrapper>
					</Overlay>
				)}

				{this.props.children(passedProps)}
			</Fragment>
		);
	}

	static propTypes = {
		children: PropTypes.func.isRequired,
		contextUsage: PropTypes.string,
	}
}

export default LoginModalHoc;
